var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: "蘇花路廊監控總覽", show_search_text: false },
    scopedSlots: _vm._u([
      {
        key: "data_table",
        fn: function() {
          return [
            _c("LandslideSWCB", {
              key: _vm.default_value_radar_monitor,
              attrs: { default_value: _vm.default_value_radar_monitor }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("LandslideTRA", {
              key: _vm.default_value_landslide,
              attrs: { default_value: _vm.default_value_landslide }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }